import { useState, useEffect, useCallback } from 'react';
import type { InsightObjectAttribute } from '@atlassian/jira-servicedesk-insight-object-types/src/common/types/object-attribute.tsx';
import type { StatusPickerOption } from '@atlassian/jira-servicedesk-insight-shared-types/src/common/types/picker-options.tsx';

export const getStatusValue = (attribute?: InsightObjectAttribute): StatusPickerOption | null => {
	if (attribute && attribute.type === 'status') {
		const [{ status }] = attribute.statusTypeValues;
		return { category: status.category, label: status.name, value: status.id };
	}
	return null;
};

export const useStatusValue = (attribute?: InsightObjectAttribute) => {
	const [value, setValue] = useState<StatusPickerOption | null>(getStatusValue(attribute));

	useEffect(() => {
		setValue(getStatusValue(attribute));
	}, [attribute]);

	const setStatusOption = useCallback((statusOption: StatusPickerOption | null) => {
		const isNoneOption = statusOption?.category === null;
		if (isNoneOption) {
			setValue(null);
		} else {
			setValue(statusOption);
		}
	}, []);

	return [value, setStatusOption] as const;
};
